import * as ActionTypes from "./ActionTypes";
import { ApiManager } from "../api/ApiManager";
import { IRosterRequest } from "../models/Roster/IRosterRequest";
import { IResourceSchedule, ResourceScheduleResponse } from "../models/Roster/RosterResponse";
import { IAddRosterRequest } from "../models/Roster/IAddRosterRequest";


export class RosterActions {
    static fetchDoctorRoster(params: IRosterRequest): Promise<IResourceSchedule[]> {
        return ApiManager.getAlbusApis().fetchRoster(params);
    }
    static updateRoster(params: IAddRosterRequest[]): Promise<ResourceScheduleResponse> {
        return ApiManager.getAlbusApis().updateRoster(params);
    }
    static getAllowedAgentTypesForAutomatedWorkingHours(): Promise<string[]> {
        return ApiManager.getOrionApis().getAllowedAgentTypesForAutomatedWorkingHours();
    }
}